import { Injectable } from '@angular/core';
import { RmsBasicCrudService } from '../../components/rms-basic-crud.service';
import { CompanyInfo } from '../../../shared/models/company/company-info.model';
import { HttpClient } from '@angular/common/http';
import { ExceptionService, UtilsService } from '../../../xform-compat';
import { Observable } from 'rxjs';
import { CompanyBasic } from '../../../shared/models';

@Injectable({
  providedIn: 'root'
})
export class CompanyInfoService extends RmsBasicCrudService<any> {

  constructor(
    http: HttpClient,
    utilsService: UtilsService,
    exceptionService: ExceptionService
  ) {
    super(http, utilsService, exceptionService);
  }

  /**
   * Update a company with the given pieces of info
   * @param companyId The id of the company to update
   * @param body The pieces of info to update the company with
   */
  public update(companyId: number, body: Array<CompanyInfo>): Observable<CompanyBasic> {
    return super.saveData(`/api/rms/companies/${companyId}/updateInfo`, body);
  }
}
